<template>
	<v-dialog v-model="editGroupNameDialog" width="600">
    <custom-dialog>
      <template v-slot:title>
        {{t('rename')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img"
						@click="editGroupNameDialog = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
            <v-row class="ma-0 pa-0 pt-2 mb-10" align="center" justify="center">
							<v-col class="ma-0 pa-0" cols="3">
								{{t('rename')}}
							</v-col>
              <v-col class="ma-0 pa-0" cols="9">
                <input class="member_input" v-model="groupName">
              </v-col>
            </v-row>
						<v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
             	<v-btn class="ma-0 pa-0" id="grey_btn" @click="editGroupNameDialog = false"
					   		width="8rem" height="2rem">{{t('back')}}</v-btn>
             	<v-btn class="ma-0 pa-0 ml-2" id="blue_btn" @click="reNameStoreGroup"
					   		width="8rem" height="2rem">{{t('change')}}</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </custom-dialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import CustomDialog from '@/components/Modal.vue';
export default {
	props: {
		dialogVisible: Boolean,
	},
	components: {
		CustomDialog
	},
	mixins: [mixin.common],
	data: () => ({
    editGroupNameDialog: false,
		currentGroupId: '',
		currentGroup: null,
		groupName: '',
	}),
	watch: {
		dialogVisible: function(item) {
			this.editGroupNameDialog = item;
			if(item) this.groupName = this.currentGroup.groupName;
		},
		editGroupNameDialog: function(item) {
			this.$emit('visible', item);
		},
		$route: {
      immediate: true,
      handler(to, from) {
        this.currentGroupId = to.query.groupId;
				this.currentGroup = this.$store.state.userData.storeGroupList.find(r => r.id === this.$route.query.groupId);
				this.groupName = this.currentGroup.groupName;
      }
    },
	},
	mounted() {
		this.currentGroupId = this.$route.query.groupId;
		this.currentGroup = this.$store.state.userData.storeGroupList.find(r => r.id === this.$route.query.groupId);
	},
	methods: {
		groupNameCheckDuplicate() {
			let savedStoreGroup = this.$store.getters.getStoreGroupList;
			if(savedStoreGroup.length > 0) {
				let duplicateCheck = savedStoreGroup.some((element) => {
					return element.groupName === this.groupName
				});
				if(duplicateCheck == false) {
					return false;
				} else { // duplicateCheck가 true일때는 groupName 중복
					return true;
				}
			} else {
				return false;
			}
		},
		reNameStoreGroup() {
			if(this.groupName === '') {
				this.showToastMessage('名前の形式が無効です。');
				return;
			}
			if(this.checkStringOnlyBlankPattern(this.groupName) || this.checkStringBlankPattern(this.groupName)) {
				this.showToastMessage('名前の形式が無効です。');
				return;
			}
			if(this.groupNameCheckDuplicate()) {
				this.showToastMessage('既に存在するグループ名です。');
				return;
			}

			this.$vloading.show();
			let params = {
				groupName: this.groupName
			};
			this.networkController.updateStoreGroup(params, this.currentGroupId)
			.then(async (res) => {
				let oldStoreGroupList = this.$store.getters.getStoreGroupList;
				let currentGroupIndex = oldStoreGroupList.findIndex(r => r.id === this.currentGroupId);
				oldStoreGroupList[currentGroupIndex].groupName = this.groupName;
				await this.$store.commit('setStoreGroupList', oldStoreGroupList);
				this.showToastMessage(this.tmb('requestSuccess'));
				this.$emit('success', true);
				this.$vloading.hide();
				this.editGroupNameDialog = false;
			}).catch(error => {
				this.$vloading.hide();
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.member_input {
  width: 100%;
  padding-left: 1em;
  color: white;
  background-color: #272727;
  border: 1px solid #4A4A4A;
  border-radius: 3px;
  height: 2rem;
}
</style>